import styled, { css } from 'styled-components';
import React, { ChangeEvent, ForwardedRef, forwardRef, useState } from 'react';

import {
  Article,
  SectionHeader,
  PhoneNumberInput,
} from '@components/molecules';
import {
  Input,
  Container,
  StyledSection,
  ContentContainer,
} from '@components/atoms';
import { device } from '@styles/mediaQuery';
import { FormBase } from '@shared/interfaces/form';
import { baseFormInitial } from '@shared/constants/form';
import GetStartedBtn from '@components/molecules/GetStartedBtn';

function ContactUs({}, ref: ForwardedRef<HTMLDivElement | null>) {
  const [formBase, setFormBase] = useState<FormBase>(baseFormInitial);

  const handleFormValues = ({ target }: ChangeEvent<HTMLInputElement>) => {
    setFormBase({ ...formBase, [target.name]: target.value });
  };

  return (
    <Section ref={ref}>
      <SectionBackground />

      <Container>
        <ContentContainer>
          <CardWrapper>
            <SectionHeader
              width={28}
              height={28}
              src="icons/message-icon.svg"
              title="Contact Us"
              titleColor="textPrimary"
              titleFontWeight={700}
              titleFontSize="36px"
              margin="30px 0 0 0"
            />

            <Article
              title=""
              wrapWidth="100%"
              wrapAlign="center"
              descriptionMaxWidth="320px"
              align="center"
              description="Our representatives will get in touch with you soon!"
            />

            <Input
              id="firstName"
              name="firstName"
              label="First Name"
              value={formBase.firstName}
              placeholder="First Name"
              onChange={handleFormValues}
              required
            />

            <Input
              id="lastName"
              name="lastName"
              label="Last Name"
              value={formBase.lastName}
              placeholder="Last Name"
              onChange={handleFormValues}
              required
            />

            <PhoneNumberInput
              object={formBase}
              objectKey="phoneNumber"
              setPhoneNumber={setFormBase}
              phoneValue={formBase.phoneNumber}
              required
            />

            <Input
              id="extraInfo"
              name="extraInfo"
              label="Additional Information"
              value={formBase.extraInfo}
              placeholder="I want to..."
              onChange={handleFormValues}
            />

            <ButtonWrapper>
              <GetStartedBtn
                formData={formBase}
                notRequiredKeys={['extraInfo']}
              />
            </ButtonWrapper>
          </CardWrapper>
        </ContentContainer>
      </Container>
    </Section>
  );
}

const Section = styled(StyledSection)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: 30px;
`;

const CardWrapper = styled.div`
  width: 100%;
  max-width: 490px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  margin: 30px auto 0;
  padding-bottom: 40px;
  border-radius: 20px;

  ${device.tablet(css`
    background-color: #f3f4f69e;
    border: 1px solid ${({ theme }) => theme.colors.cardBorder};
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
  `)}
`;

const SectionBackground = styled.div`
  display: none;

  background-image: image-set(
    url('/images/gl-truck-1x.webp') 1x,
    url('/images/gl-truck-2x.webp') 2x
  );
  background-repeat: no-repeat;
  background-size: contain;

  ${device.laptopS(css`
    width: 100%;
    max-width: 1440px;
    height: 450px;
    top: 130px;
    position: absolute;
    display: block;
  `)}
  s
`;

export default forwardRef(ContactUs);
